import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    type MRT_ColumnDef,
    type MRT_ColumnFiltersState,
    type MRT_Row,
    useMaterialReactTable,
} from 'material-react-table';
import {Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, Stack} from '@mui/material';
import {useQueryClient,} from '@tanstack/react-query';

import {useNavigate} from "react-router-dom";

import {VersOreDTO} from "../gestversore/types";
import {useCreateValidOre, useDeleteValidOre, useGetValVersOreDTO} from "./Services";
import {useTabSettings} from "../../common/Services";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ValVersOreExp from "./ValVersOreExp";
import {ValVersOreDTO} from "./types";

interface ListaValVersOreNewProps {
  // propflgtemp: string;
}

// const VersOre = () => {
const ListaValVersOre: React.FC<ListaValVersOreNewProps> = () => {

    interface FlagValCheckboxProps {row: MRT_Row<ValVersOreDTO>; saving: boolean;  }
    const FlagValCheckbox: React.FC<FlagValCheckboxProps> = ({ row, saving }) => {
            // const [checked, setChecked] = useState(row.original.flgval === 'Y');
            //
            // useEffect(() => {
            //     // Sync checkbox state with row data
            //     setChecked(row.original.flgval === 'Y');
            //   }, [row.original.flgval]);
            //
            // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            //   const newValue = e.target.checked ? 'Y' : 'N';
            //   setChecked(e.target.checked);
            //   row.original.flgval = newValue;
            // };
            const currentValue =  editedFlags[row.original.nrrel ?? 0] ?? row.original.flgval ?? 'N';

            const checked = currentValue === 'Y';

            const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
              const newValue = e.target.checked ? 'Y' : 'N';
              if (row.original.nrrel != null) {
                setEditedFlags((prev) => ({
                  ...prev,
                  [row.original.nrrel as number]: newValue,
                }));
              }
            };

            const isDisabled = saving || row.original.flgdisabled === 'Y';


            return (
              <Checkbox
                checked={checked}
                onChange={handleChange}

                disabled={isDisabled}
               sx={{
                    padding: '0', // Remove any default padding around the checkbox
                    margin: '0',  // Remove any default margin around the checkbox
                    '& .MuiSvgIcon-root': {
                      fontSize: '1.3rem', // Adjust the size of the checkbox icon (if needed)
                    },
                  }}
              />
            );
          };





  const queryClient = useQueryClient();
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});

   const [editedFlags, setEditedFlags] = useState<Record<number, 'Y' | 'N'>>({});

  const [globalFilter, setGlobalFilter] = useState('');
  const [saving, setSaving] = useState(false);

  const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);

  const [initialRowsWithFlagVal, setInitialRowsWithFlagVal] = useState<VersOreDTO[]>([]);

  const { mutateAsync: createValidOre, isPending: isCreatingValidOre } = useCreateValidOre();
  const { mutateAsync: deleteValidOre, isPending: isDeletingValidOre } = useDeleteValidOre();


  const isAdmin = localStorage.getItem('isadmin');
  const storeCodDip = localStorage.getItem('coddip');


  const keyusername = localStorage.getItem('keyusername') || 'NN';

  const {  columnVisibility,  setColumnVisibility,  columnFilters,  setColumnFilters,  sorting,  setSorting, pagination,  setPagination,  saveTabSettings, isTabSetReady} = useTabSettings('ListaValVersOre', keyusername);

// console.log(columnFilters);

  const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);

 const {  data: { results = [], count } = {} ,isError: isLoadingValVersOreDTOError, isFetching: isFetchingValVersOreDTO, isLoading: isLoadingValVersOreDTO, } = useGetValVersOreDTO(pagination,columnFilters,globalFilter,sorting, isTabSetReady);


 // const [localResults, setLocalResults] = useState<VersOreDTO[]>([]);


  // useEffect(() => {
  //     if (results && results.length > 0) {
  //       const flaggedRows = results.filter((row) => row.flgval === 'Y');
  //       setInitialRowsWithFlagVal(flaggedRows); // Original flagged rows
  //       setLocalResults(results); // Full editable table data
  //     }
  //   }, [results]);

useEffect(() => {
  const flaggedRows = results.filter((row) => row.flgval === 'Y');
  setInitialRowsWithFlagVal(flaggedRows);
}, [results]);


    // const handleSelectAll = () => {
    //   if (!results || results.length === 0) return;
    //
    //   // Update only localResults to ensure a clean separation
    //   const updatedRows = results.map((row) => ({
    //     ...row,
    //     flgval: 'Y', // Set all rows' flgval to 'Y'
    //   }));
    //
    //   setLocalResults(updatedRows); // Update localResults
    // };

    const handleSelectAll = () => {
          if (!results || results.length === 0) return;

          const newFlags: Record<number, 'Y' | 'N'> = {};
          results.forEach((row) => {
            if (row.nrrel != null) {
              newFlags[row.nrrel] = 'Y';
            }
          });

          setEditedFlags((prev) => ({
            ...prev,
            ...newFlags,
          }));
        };




    // const handleDeselectAll = () => {
    //       if (!results || results.length === 0) {
    //         return; // Exit early if no data is available
    //       }
    //
    //      const updatedRows = results.map((row) => ({
    //         ...row,
    //         flgval: 'N', // Set all rows' flgval to 'N'
    //       }));
    //
    //           // setInitialRowsWithFlagVal([]); // Clear the initialRowsWithFlagVal state
    //           setLocalResults(updatedRows); // Update localResults if necessary
    //
    //        // console.log("All rows deselected:", updatedRows);
    // };

            const handleDeselectAll = () => {
              if (!results || results.length === 0) return;

              const newFlags: Record<number, 'Y' | 'N'> = {};
              results.forEach((row) => {
                if (row.nrrel != null) {
                  newFlags[row.nrrel] = 'N';
                }
              });

              setEditedFlags((prev) => ({
                ...prev,
                ...newFlags,
              }));
            };

const handleSaveSelected = async () => {
  setSaving(true);

  try {

     // Get rows with 'Y' flag
    // const rowsWithFlagVal = localResults.filter((row) => row.flgval === 'Y');

      const currentRows = results.map((row) => ({
                      ...row,
                      flgval: editedFlags[row.nrrel ?? 0] ?? row.flgval,
                    }));

      const rowsWithFlagVal = currentRows.filter((row) => row.flgval === 'Y');





    // Rows to delete: Initially valid but now unflagged
    const rowsToDelete = initialRowsWithFlagVal.filter(
      (row) => !rowsWithFlagVal.some((currentRow) => currentRow.nrrel === row.nrrel)
    );
    //console.log("rowsToDelete: ",rowsToDelete);


    const rowsToSave = rowsWithFlagVal.filter(
      (row) => !initialRowsWithFlagVal.some((initialRow) => initialRow.nrrel === row.nrrel)
    );
     // console.log("rowsToSave: ",rowsToSave);

    // Delete rows
    for (const row of rowsToDelete) {
      if (row.nrrel !== undefined) {
        await deleteValidOre(row.nrrel); // Delete row from the database
      }
    }

    // Save rows
    for (const row of rowsToSave) {
      const myValidOre = {
        nrrel: row.nrrel,
        ref: row.ref,
        dataval: new Date(), // Set the current date as 'dataval'
      };
      await createValidOre(myValidOre); // Save row to the database
    }

    // Trigger a refetch to ensure results sync with the backend
    await queryClient.invalidateQueries({ queryKey: ['fetchValVersOreDTO'] });

    // Update initialRowsWithFlagVal to match the latest state
    const updatedResults = results.map((row) => ({
      ...row,
      flgval: rowsWithFlagVal.some((flaggedRow) => flaggedRow.nrrel === row.nrrel) ? 'Y' : 'N',
    }));
    setInitialRowsWithFlagVal(updatedResults.filter((row) => row.flgval === 'Y'));

    // Update initial state to reflect saved changes
    // setInitialRowsWithFlagVal(rowsWithFlagVal);

  } catch (error) {
    console.error('Error saving selected rows:', error);
  } finally {
    setSaving(false);
    setEditedFlags({});
  }
};




 const navigate = useNavigate();

 const columns = useMemo<MRT_ColumnDef<VersOreDTO>[]>(
  () => [

    {
      accessorKey: "flgval",
      header: "VAL(Y/N)",
      Cell: ({ row }) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FlagValCheckbox row={row} saving={saving}  />
        </Box>
      ),
      enableEditing: true,
      size: 5,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
        sx: {
          py: "2.5px",
        },
      },
    },

    {
      accessorKey: 'nrrel',
      header: 'NRREL',
      size: 5,
      enableEditing: false,
    },
    // {
    //   accessorKey: 'desditta',
    //   header: 'Ditta',
    //   size: 5
    //   // enableEditing: false,
    //   // Cell: ({ cell }) => {
    //   //   return cell.getValue() === 2 ? 'BS' : 'IN4IT';
    //   // }
    //   ,
    // },
     {
          accessorKey: 'datareg',
          header: 'Data',
          size: 2,
          filterVariant: 'date-range',
          Cell: ({ cell }) => {
            const value = cell.getValue<string>();
            if (!value) return '';

            return new Date(value).toLocaleDateString('it-IT', {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
            });
          },
        },
    // {
    //   accessorKey: 'variante',
    //   header: 'Rif.NRREL',
    //   size: 10,
    //   enableEditing: false,
    // },

    {
      accessorKey: 'ref',
      header: 'Ref',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'coddip',
      header: 'Dip',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'ore',
      header: 'Ore',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'opzione',
      header: 'Opz.',
      size: 5,
      enableEditing: false,
    },

    { accessorKey: 'ragsoccli', header: 'Cliente', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 30 ? `${value.substring(0, 20)}...` : value}</span> ); }, },


    { accessorKey: 'desprog', header: 'Progetto', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 30 ? `${value.substring(0, 30)}...` : value}</span> ); }, },

      {
          accessorKey: 'note',
          header: 'Note',
          size: 10,
          enableEditing: true,
          Cell: ({cell}) => {
              const rawValue = cell.getValue();
              const value = typeof rawValue === 'string' ? rawValue : '';

              return (
                  <span title={value}>
          {value.length > 150 ? `${value.substring(0, 150)}...` : value}
        </span>
              );
          }
      },

    // {
    //   accessorKey: 'codatt',
    //   header: 'CodAtt',
    //   size: 10,
    //   enableEditing: false,
    // },
    // {
    //   accessorKey: 'codnodo',
    //   header: 'CodNodo',
    //   size: 10,
    //   enableEditing: false,
    // },
    {
          accessorKey: 'datains',
          header: 'DataIns',
          size: 2,
          filterVariant: 'date-range',
          Cell: ({ cell }) => {
            const value = cell.getValue<string>();
            if (!value) return '';

            return new Date(value).toLocaleDateString('it-IT', {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
            });
          },
        },
    // {
    //   accessorKey: 'desnodo',
    //   header: 'DesNodo',
    //   size: 20,
    //   enableEditing: false,
    // },
    // {
    //   accessorKey: 'desatt',
    //   header: 'DesAtt',
    //   size: 20,
    //   enableEditing: false,
    // },
    // {
    //   accessorKey: 'codagente',
    //   header: 'CodAgente',
    //   size: 10,
    //   enableEditing: false,
    // },
    {
      accessorKey: 'nomeagente',
      header: 'Agente',
      size: 10,
      enableEditing: false,
    },

  ],
  [validationErrors, editedFlags, saving]
);





  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact', },
    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: false,
    enableRowActions: false,
    enableColumnActions: false,
    enableGlobalFilter: true,
    muiSearchTextFieldProps: {
        placeholder: 'NNREL,Ref,Prog,Note',
        sx: { minWidth: "600px", fontSize: '0.75rem', },
        variant: 'outlined',
      },
    getRowId: (row) => (row.nrrel ? row.nrrel.toString() : ''),
    muiToolbarAlertBannerProps: isLoadingValVersOreDTOError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },

      muiTableBodyCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '.9rem',
          },
        },

     muiTableHeadCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '0.9rem',
          },
        },


    onGlobalFilterChange: setGlobalFilter,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),
    onColumnFiltersChange: setDraftColumnFilters,
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },


    renderTopToolbarCustomActions: ({ table }) => (
     <>
      <Stack
              direction="row"
              spacing={0}
              sx={{
                width: '60%',
                padding: '4px',
                alignItems: 'center',
              }}
            >
       <Box sx={{ width: '25%' }}>
         <Button variant="contained"  sx={{ width: 160 }}  onClick={handleSaveSelected} disabled={saving}>Salva </Button>
       </Box>

       <Box sx={{ width: '25%' }}>
         <Button variant="contained"  sx={{ width: 160 }} onClick={handleSelectAll} disabled={saving}>Seleziona Tutti</Button>
       </Box>

       <Box sx={{ width: '25%' }}>
            <Button variant="contained"  sx={{ width: 160 }} onClick={handleDeselectAll} disabled={saving}> Desel. Tutti</Button>
        </Box>

          <Box sx={{ width: '25%' }}>
                  <Button
                    variant="contained"
                    sx={{ width: 160 }}
                    onClick={() => setIsDialogExporterOpen(true)}
                    startIcon={<FileDownloadIcon />}
                    disabled={saving}
                  >
                    EXPORT DATI
                  </Button>
                </Box>


              <Box sx={{ width: '25%'}}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setColumnFilters(draftColumnFilters);
                    saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                  }}
                  sx={{ width: 160 }}
                >
                  Applica Filtri
                </Button>
              </Box>


      </Stack>
    </>
   ),



    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,


    state: {
       isLoading: isLoadingValVersOreDTO,
       // isSaving: isCreatingValVersOre || isUpdatingValVersOre || isDeletingValVersOre,
       // isSaving:  isDeletingValVersOre,
       showAlertBanner: isLoadingValVersOreDTOError,
       showProgressBars: isFetchingValVersOreDTO,
      columnVisibility,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });


  return (
    <Box sx={{ mt: '60px' }}>
      <MaterialReactTable table={table} /> {/* Your table rendering */}


      {/* Dialog with CircularProgress spinner */}
      <Dialog
        open={saving} // Show the dialog only when saving is true
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/*<DialogTitle>Saving...</DialogTitle>*/}
        <DialogContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '200px',
            minHeight: '100px',
          }}
        >
          <CircularProgress />
        </DialogContent>
      </Dialog>

  {isDialogExporterOpen && (
      <ValVersOreExp
        pagination={pagination}
        columnFilters={columnFilters}
        globalFilter={globalFilter}
        sorting={sorting}
        columnVisibility={columnVisibility}
        columns={columns}
        onClose={() => setIsDialogExporterOpen(false)}
      />
    )}



    </Box>
  );


};

export default ListaValVersOre;


